

























import Vue from "vue";
import { ElementColors } from "@/common/theme/ElementColors";

export default Vue.extend({
  name: "PPClaimOrder",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    currentPicker: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ElementColors: ElementColors,
    };
  },
  computed: {
    isDialogOpen(): boolean {
      return this.dialog;
    },
  },
  methods: {
    onYes(): void {
      this.$emit("claim");
    },
    onNo(): void {
      this.$emit("close");
    },
  },
});
